import { WidgetType } from '../../../stores/TemplatesStore';
import { TranslationKey } from '../../../../i18n/i18n';
import { WidgetFeature } from './WidgetFeatureList/WidgetFeatureList';

type FeatureList = {
  [type in WidgetType]: {
    id: WidgetType;
    title: TranslationKey;
    features: WidgetFeature[];
  };
};

export const widgetFeatureListConfig: FeatureList = {
  all: {
    id: WidgetType.All,
    title: 'widget.all.title',
    features: [
      {
        id: 'feature1',
        title: 'widget.all.feature1.title',
        description: 'widget.all.feature1.description',
        imagePath: '/widget/all/1.png',
      },
      {
        id: 'feature2',
        title: 'widget.all.feature2.title',
        description: 'widget.all.feature2.description',
        imagePath: '/widget/all/2.png',
      },
      {
        id: 'feature3',
        title: 'widget.all.feature3.title',
        description: 'widget.all.feature3.description',
        imagePath: '/widget/all/3.png',
      },
      {
        id: 'feature4',
        title: 'widget.all.feature4.title',
        description: 'widget.all.feature4.description',
        imagePath: '/widget/all/4.png',
      },
    ],
  },
  'online-store': {
    id: WidgetType.OnlineStore,
    title: 'widget.online-store.title',
    features: [
      {
        id: 'feature1',
        title: 'widget.online-store.feature1.title',
        description: 'widget.online-store.feature1.description',
        imagePath: '/widget/online-store/1.png',
      },
      {
        id: 'feature2',
        title: 'widget.online-store.feature2.title',
        description: 'widget.online-store.feature2.description',
        imagePath: '/widget/online-store/2.png',
      },
      {
        id: 'feature3',
        title: 'widget.online-store.feature3.title',
        description: 'widget.online-store.feature3.description',
        imagePath: '/widget/online-store/3.png',
      },
      {
        id: 'feature4',
        title: 'widget.online-store.feature4.title',
        description: 'widget.online-store.feature4.description',
        imagePath: '/widget/online-store/4.png',
      },
    ],
  },
  blog: {
    id: WidgetType.Blog,
    title: 'widget.blog.title',
    features: [
      {
        id: 'feature1',
        title: 'widget.blog.feature1.title',
        description: 'widget.blog.feature1.description',
        imagePath: '/widget/blog/1.png',
      },
      {
        id: 'feature2',
        title: 'widget.blog.feature2.title',
        description: 'widget.blog.feature2.description',
        imagePath: '/widget/blog/2.png',
      },
      {
        id: 'feature3',
        title: 'widget.blog.feature3.title',
        description: 'widget.blog.feature3.description',
        imagePath: '/widget/blog/3.png',
      },
      {
        id: 'feature4',
        title: 'widget.blog.feature4.title',
        description: 'widget.blog.feature4.description',
        imagePath: '/widget/blog/4.png',
      },
    ],
  },
  photography: {
    id: WidgetType.Photography,
    title: 'widget.photography.title',
    features: [
      {
        id: 'feature1',
        title: 'widget.photography.feature1.title',
        description: 'widget.photography.feature1.description',
        imagePath: '/widget/photography/1.png',
      },
      {
        id: 'feature2',
        title: 'widget.photography.feature2.title',
        description: 'widget.photography.feature2.description',
        imagePath: '/widget/photography/2.png',
      },
      {
        id: 'feature3',
        title: 'widget.photography.feature3.title',
        description: 'widget.photography.feature3.description',
        imagePath: '/widget/photography/3.png',
      },
      {
        id: 'feature4',
        title: 'widget.photography.feature4.title',
        description: 'widget.photography.feature4.description',
        imagePath: '/widget/photography/4.png',
      },
    ],
  },
  events: {
    id: WidgetType.Events,
    title: 'widget.events.title',
    features: [
      {
        id: 'feature1',
        title: 'widget.events.feature1.title',
        description: 'widget.events.feature1.description',
        imagePath: '/widget/events/1.png',
      },
      {
        id: 'feature2',
        title: 'widget.events.feature2.title',
        description: 'widget.events.feature2.description',
        imagePath: '/widget/events/2.png',
      },
      {
        id: 'feature3',
        title: 'widget.events.feature3.title',
        description: 'widget.events.feature3.description',
        imagePath: '/widget/events/3.png',
      },
      {
        id: 'feature4',
        title: 'widget.events.feature4.title',
        description: 'widget.events.feature4.description',
        imagePath: '/widget/events/4.png',
      },
    ],
  },
  business: {
    id: WidgetType.Business,
    title: 'widget.business.title',
    features: [
      {
        id: 'feature1',
        title: 'widget.business.feature1.title',
        description: 'widget.business.feature1.description',
        imagePath: '/widget/business/1.png',
      },
      {
        id: 'feature2',
        title: 'widget.business.feature2.title',
        description: 'widget.business.feature2.description',
        imagePath: '/widget/business/2.png',
      },
      {
        id: 'feature3',
        title: 'widget.business.feature3.title',
        description: 'widget.business.feature3.description',
        imagePath: '/widget/business/3.png',
      },
      {
        id: 'feature4',
        title: 'widget.business.feature4.title',
        description: 'widget.business.feature4.description',
        imagePath: '/widget/business/4.png',
      },
    ],
  },
};
